import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import Problem from "./Problem";
import Methodology from "./Methodology";
import Comparison from "./Comparison";
import TargetAudience from "./TargetAudience";
import AboutGiulia from "./AboutGiulia";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import ApplicationCTA from "./ApplicationCTA";
import CommunityCTA from "./CommunityCTA";
import Footer from "./Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-beige text-chocolate">
      <Navbar />
      <Hero />
      <Problem />
      <Methodology />
      <Comparison />
      <TargetAudience />
      <AboutGiulia />
      <Testimonials />
      <FAQ />
      <ApplicationCTA />
      <CommunityCTA />
      <Footer />
    </div>
  );
}
